import {Box, Flex, Text} from 'exsportia-components'
import {useFormikContext} from 'formik'
import {FC, useCallback} from 'react'

import {ForgotPasswordForm} from '../../services/auth/forms/forgot-password-form'
import {SignInFormType} from '../../services/auth/forms/sign-in-form'
import {useAppLoading} from '../../services/global/hooks'
import {Button} from '../../ui/components/button/button'
import {Input} from '../../ui/components/input/input'
import {useLocale} from '../../utils/i18n'
import {useModalActions} from '../../utils/modals'

type SignInStepProps = {
  backAction?: (e: Event) => void
  phoneLoginAction?: () => void
}

const PhoneIcon: FC = () => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
  >
    <path d='M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z' />
  </svg>
)

export const SignInStep: FC<SignInStepProps> = ({backAction, phoneLoginAction}) => {
  const {l} = useLocale()
  const {openModal} = useModalActions()
  const {isLoading} = useAppLoading()
  const {handleSubmit, values} = useFormikContext<SignInFormType>()
  const handleOpenForgotPasswordModal = useCallback(
    () =>
      openModal({
        component: <ForgotPasswordForm email={values.email} />,
        title: l('forgotPassword'),
        footerConfig: {
          disabled: true,
        },
      }),
    [openModal, l, values.email],
  )

  return (
    <Box pb={'24px'}>
      <Flex mb='16px'>
        <Text text={l('enter_your_password', {caseAction: 'capitalize'})} />
      </Flex>
      <Input
        id={'password'}
        placeholder={'password'}
        type='password'
      />
      <Box mt={'16px'}>
        <Button
          type='flat'
          onClick={handleOpenForgotPasswordModal}
          disabled={isLoading}
        >
          {l('forgotPassword')}
        </Button>
      </Box>
      <Flex
        gap='16px'
        mt={'16px'}
      >
        {backAction && (
          <Button
            disabled={isLoading}
            onClick={backAction}
            type='secondary'
          >
            {l('back')}
          </Button>
        )}
        <Button
          isLoading={isLoading}
          disabled={isLoading}
          // @ts-ignore
          onClick={handleSubmit}
        >
          {l('signin')}
        </Button>
      </Flex>
      {phoneLoginAction && (
        <Box mt={'16px'}>
          <Button
            type={'secondary'}
            onClick={phoneLoginAction}
            disabled={isLoading}
          >
            <Flex
              alignItems={'center'}
              justifyContent={'center'}
            >
              <PhoneIcon />
              <Box ml={'8px'}>
                {l('continueWithPhone', {defaultMessage: 'Continue with Phone'})}
              </Box>
            </Flex>
          </Button>
        </Box>
      )}
    </Box>
  )
}
